import { useTranslations } from "next-intl";

import { LogoutIcon } from "@/components/assets/icons";

const Logout = () => {
  const t = useTranslations();

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/log-in";
  };

  return (
    <div
      onClick={handleLogout}
      className="flex h-[50px] w-full cursor-pointer items-center justify-center rounded-[14px] bg-[#f9f9f9] p-4"
    >
      <LogoutIcon />
      <p className="font-medium text-red-600">{t("logout")}</p>
    </div>
  );
};

export { Logout };
